// frontend/src/pages/CheckoutCanceladoPage/CheckoutCanceladoPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Result } from 'antd';
import logo from '../../assets/images/logo_horizontal_fundo_transparente.png';

const CheckoutCanceladoPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'var(--color-background)',
      }}
    >
      <Card style={{ width: 440, textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <img
          src={logo}
          alt="Logo Saldo Ativo"
          style={{ width: 220, maxWidth: '80%', marginBottom: 24, display: 'block', margin: '0 auto 24px' }}
        />
        <Result
          status="info"
          title="Pagamento cancelado"
          subTitle="Você pode escolher outro plano quando quiser."
          extra={[
            <Button type="primary" key="planos" size="large" block onClick={() => navigate('/checkout')}>
              Escolher plano
            </Button>,
          ]}
        />
      </Card>
    </div>
  );
};

export default CheckoutCanceladoPage;
